import {fetchRemoteResult,postRemote,putRemoteResult,fetchRemoteJson} from '../../Api/api-util';
import securityApi from '../../Util/security';

const endpoint = '/api/SprintPlanning/';

const jiraBaseUrl = 'https://datanext.atlassian.net/browse/';

export default {
    getIssues(jiraFilterType, startAt) {
        return fetchRemoteResult(
            `${endpoint}SprintIssue?selectedFilter=${jiraFilterType}&startAt=${startAt}&raw=true`
        );
    },
    getIssueTypes() {
        return fetchRemoteResult(`${endpoint}IssueTypes`);
    },
    getFilters() {
        return fetchRemoteResult(`${endpoint}Filters`);
    },
    getUsers() {
        return fetchRemoteResult(`${endpoint}Users`);
    },
    getComments(key) {
        return new Promise((resolve, reject) => {
            fetchRemoteResult(`${endpoint}Comments?key=${key}`).then(
                (response) => {
                    let comments = response.comments;
                    comments = comments ? comments.reverse() : []; //last comment first
                    resolve(comments);
                },
                reject
            ).catch(reject);
        });
    },
    getPriorities() {
        return fetchRemoteResult(`${endpoint}Priorities`);
    },
    getMetadata(projectKey) {
        return fetchRemoteResult(`${endpoint}Metadata?projectKey=${projectKey}`);
    },
    getStatuses() {
        return fetchRemoteResult(`${endpoint}Status`);
    },
    getIssueMeta(key) {
        return fetchRemoteResult(`${endpoint}IssueMeta?key=${key}`);
    },
    getTransitions(key) {
        return fetchRemoteResult(`${endpoint}Transitions?key=${key}`);
    },
    getAttachments(key) {
        return new Promise((resolve, reject) => {
            fetchRemoteResult(`${endpoint}Attachments?key=${key}`).then(
                (response) => {
                    const attachments = response.fields.attachment;
                    resolve(attachments || []);
                },
                reject
            ).catch(reject);
        });
    },
    postTransition(key, transition) {
        return postRemote(`${endpoint}Transition`, { key, transition });
    },
    putAssignee(key, accountId) {
        return putRemoteResult(`${endpoint}Assignee`, { key, accountId });
    },
    putIssue(key, update) {
        return putRemoteResult(`${endpoint}PutIssue`, { key, update });
    },

    validateCommentsReadPermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningComments,
            securityApi.PermissionGrantTypes.Read
        );
    },
    validateCommentsWritePermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningComments, 
            securityApi.PermissionGrantTypes.Write
        );
    },
    validateTimeTrackingReadPermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningTimeTracking,
            securityApi.PermissionGrantTypes.Read
        );
    },
    validateTimeTrackingWritePermission() {
        return securityApi.validatePermission(
            securityApi.Permissions.SprintPlanningTimeTracking,
            securityApi.PermissionGrantTypes.Write
        );
    },
    
    jiraBaseUrl
};
